import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Survey = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 16 18'
    >
      <path
        stroke={primaryColorToUse}
        strokeWidth='1.25'
        d='M3.962 1.875c-1.297.04-2.07.183-2.605.718-.732.734-.732 1.913-.732 4.272v5.422c0 2.36 0 3.539.732 4.272s1.911.733 4.268.733h4.167c2.357 0 3.536 0 4.267-.734.734-.732.734-1.911.734-4.271V6.865c0-2.358 0-3.538-.734-4.272-.534-.535-1.307-.679-2.604-.718'
      />
      <path
        stroke={primaryColorToUse}
        strokeLinejoin='round'
        strokeWidth='1.25'
        d='M3.958 2.083c0-.805.654-1.458 1.459-1.458H10a1.458 1.458 0 0 1 0 2.917H5.417a1.46 1.46 0 0 1-1.459-1.459Z'
      />
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeWidth='1.25'
        d='M3.128 7.292h3.334'
      />
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.25'
        d='M8.962 8.125s.416 0 .833.834c0 0 1.323-2.084 2.5-2.5'
      />
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeWidth='1.25'
        d='M3.128 12.292h3.334'
      />
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.25'
        d='M8.962 13.125s.416 0 .833.834c0 0 1.323-2.084 2.5-2.5'
      />
    </svg>
  );
};
